import './rich-text.less';
import PropTypes from 'prop-types';
import React from 'react';
import RichTextEditor from 'react-rte';

const propTypes = {
	input: PropTypes.object,
	meta: PropTypes.object,
	placeholder: PropTypes.string
};

class RichTextField extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.input.value === '' ?
				RichTextEditor.createEmptyValue() :
				RichTextEditor.createValueFromString(this.props.input.value, 'html')
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.input.value !== this.state.value.toString('html')) {
			this.setState({
				value: nextProps.input.value ?
					RichTextEditor.createValueFromString(nextProps.input.value, 'html') :
					RichTextEditor.createEmptyValue()
			});
		}
	}

	onChange(value) {
		const isTextChanged = this.state.value.toString('html') != value.toString('html');
		this.setState({value}, e => isTextChanged && this.props.input.onChange(value.toString('html')));
	}

	render() {
		return (
			<div className="form-element-rich-text">
				<div className="form-element-rich-text__label">{this.props.placeholder}</div>

				<RichTextEditor value={this.state.value} onChange={this.onChange.bind(this)} />

				{this.props.meta.touched && this.props.meta.error && (
					<div className="form-element-rich-text__error"><span>{ this.props.meta.error }</span></div>
				)}

			</div>
		);
	}
}

RichTextField.propTypes = propTypes;

export default RichTextField;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/rich-text.js